import {
  dataSourcesActionCreators,
  dataSourcesStardogRequestDispatchers,
} from 'src/actions/data-sources/actionCreators';
import { DataSourcesActionType } from 'src/actions/data-sources/actionTypes';
import { connectionSelector } from 'src/selectors/connection';
import { isStardogFeatureSupportedSelector } from 'src/selectors/isStardogFeatureSupported';
import { permissionsUsernameSelector } from 'src/selectors/permissions';
import {
  connectionAsyncActions,
  connectionsSlice,
} from 'src/store/connections/connections.slice';
import { SqlDataSource } from 'src/store/state/dataSources';
import { AppDispatch } from 'src/store/store';
import { ReduxStateGetter } from 'src/store/types';

export const addDataSource =
  (newDataSource: SqlDataSource) =>
  async (dispatch: AppDispatch, getState: ReduxStateGetter) => {
    const state = getState();
    const connection = connectionSelector(state);
    const permissionsUsername = permissionsUsernameSelector(state);
    const isCatalogSupported = isStardogFeatureSupportedSelector(
      'isCatalogSupported',
      connection
    )(state);
    const isDataSourceAutomaticMetadataRefreshSupported =
      isStardogFeatureSupportedSelector(
        'isDataSourceAutomaticMetadataRefreshSupported',
        connection
      )(state);
    const isDataSourceTablesEndpointSupported =
      isStardogFeatureSupportedSelector(
        'isDataSourceTablesEndpointSupported',
        connection
      )(state);

    if (!connection) {
      return false;
    }

    dispatch(dataSourcesActionCreators.addDataSourceStarted());

    const addDataSourceResponse =
      await dataSourcesStardogRequestDispatchers.addDataSource(newDataSource);

    if (
      addDataSourceResponse.type ===
      DataSourcesActionType.ADD_DATA_SOURCE_FAILURE
    ) {
      dispatch(dataSourcesActionCreators.addDataSourceFinished());
      return false;
    }
    if (!isDataSourceAutomaticMetadataRefreshSupported) {
      await dataSourcesStardogRequestDispatchers.refreshDataSourceTypeMetadata(
        newDataSource.id,
        connection
      );
    }
    await dataSourcesStardogRequestDispatchers.requestDataSourceOptions(
      newDataSource.id,
      connection
    );

    if (!isDataSourceTablesEndpointSupported) {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTableMetadata(
        newDataSource.id,
        isCatalogSupported
      );
    } else {
      await dataSourcesStardogRequestDispatchers.requestDataSourceTables(
        newDataSource.id,
        isCatalogSupported
      );
    }

    dispatch(dataSourcesActionCreators.addDataSourceFinished());

    // Refresh permissions after successful data source creation since the user may have new permissions
    // (e.g., if the user created the data source, they may now have permissions on it)
    if (permissionsUsername) {
      dispatch(
        connectionAsyncActions.requestCurrentPermissions({
          username: permissionsUsername,
        })
      );
    } else {
      dispatch(connectionsSlice.actions.permissionsLookupSkipped());
    }

    return true;
  };
